import { getSelectorRoot } from 'utils/selectors';

const getBetSlip = getSelectorRoot('betSlip');

// Booking
const getBookBetId = getBetSlip('bookBetId');

// Bonus balance
const getUseBonusBalance = getBetSlip('useBonusBalance');

// Book Bet
const getIsBookingMode = getBetSlip('isBookingMode');

// Quick bet
const getQuickBetStake = getBetSlip('quickBetStake');
const getShouldShowQuickBetInfoPopover = getBetSlip(
  'shouldShowQuickBetInfoPopover'
);

const getQuickBetEnabled = getBetSlip('quickBetEnabled');
const getQuickBetInProcessCount = getBetSlip('quickBetInProcessCount');
const getQuickBetSelectedEventId = getBetSlip('quickBetSelectedEventId');

export {
  getBookBetId,
  getUseBonusBalance,
  getIsBookingMode,
  getQuickBetStake,
  getShouldShowQuickBetInfoPopover,
  getQuickBetEnabled,
  getQuickBetInProcessCount,
  getQuickBetSelectedEventId
};
